var _path, _path2, _mask, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 9.8001C17.2 11.5674 15.7673 13.0001 14 13.0001C12.2327 13.0001 10.8 11.5674 10.8 9.8001C10.8 8.03279 12.2327 6.6001 14 6.6001C15.7673 6.6001 17.2 8.03279 17.2 9.8001Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15C27 22.1797 21.1797 28 14 28C6.8203 28 1 22.1797 1 15C1 7.8203 6.8203 2 14 2C21.1797 2 27 7.8203 27 15Z",
    stroke: "white",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_67_2081",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.028 24.5249C23.7607 19.6672 22.2734 16.125 13.9998 16.125C5.72646 16.125 4.23917 19.6672 3.9718 24.5249"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.031 24.6348C22.0917 25.7377 23.035 26.5826 24.1379 26.5219C25.2408 26.4612 26.0856 25.5179 26.025 24.415L22.031 24.6348ZM1.97482 24.415C1.91412 25.5179 2.75899 26.4612 3.86189 26.5219C4.96479 26.5826 5.90807 25.7377 5.96878 24.6348L1.97482 24.415ZM26.025 24.415C25.8863 21.8948 25.4242 19.1562 23.456 17.1151C21.4636 15.0489 18.3591 14.125 13.9998 14.125V18.125C17.9142 18.125 19.6901 18.9722 20.5766 19.8916C21.4872 20.836 21.9024 22.2973 22.031 24.6348L26.025 24.415ZM13.9998 14.125C9.64071 14.125 6.53619 15.0489 4.54386 17.1151C2.57567 19.1562 2.11354 21.8948 1.97482 24.415L5.96878 24.6348C6.09743 22.2974 6.51263 20.836 7.42327 19.8916C8.30977 18.9722 10.0856 18.125 13.9998 18.125V14.125Z",
    fill: "white",
    mask: "url(#path-3-inside-1_67_2081)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c3dba96badcb3bca72731dfc643eb072.svg";
export { ForwardRef as ReactComponent };